import { c as _c } from "react/compiler-runtime";
import React from 'react';
import Icon, { Path } from './base/Icon';
import type { BaseIconProps } from './types';
const BotIcon = t0 => {
  const $ = _c(4);
  const {
    size: t1,
    color: t2
  } = t0;
  const size = t1 === undefined ? 24 : t1;
  const color = t2 === undefined ? "white" : t2;
  let t3;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <Path d="M12 2C13.1 2 14 2.9 14 4C14 4.5 13.8 5 13.5 5.3L15 6.8C15.6 6.3 16.3 6 17 6C18.7 6 20 7.3 20 9V10H22V12H20V14H22V16H20V17C20 18.7 18.7 20 17 20H7C5.3 20 4 18.7 4 17V16H2V14H4V12H2V10H4V9C4 7.3 5.3 6 7 6C7.7 6 8.4 6.3 9 6.8L10.5 5.3C10.2 5 10 4.5 10 4C10 2.9 10.9 2 12 2M7 8C6.4 8 6 8.4 6 9V17C6 17.6 6.4 18 7 18H17C17.6 18 18 17.6 18 17V9C18 8.4 17.6 8 17 8H7M9 11C9.6 11 10 11.4 10 12C10 12.6 9.6 13 9 13C8.4 13 8 12.6 8 12C8 11.4 8.4 11 9 11M15 11C15.6 11 16 11.4 16 12C16 12.6 15.6 13 15 13C14.4 13 14 12.6 14 12C14 11.4 14.4 11 15 11M9 15H15V16H9V15Z" />;
    $[0] = t3;
  } else {
    t3 = $[0];
  }
  let t4;
  if ($[1] !== color || $[2] !== size) {
    t4 = <Icon viewBox="0 0 24 24" height={size} width={size} fill={color}>{t3}</Icon>;
    $[1] = color;
    $[2] = size;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  return t4;
};
export default BotIcon;